export function InfoIcon() {
  return <img src="/pictures/info-icon.png" alt="info-icon" />;
}
